import { createMigration } from './utils';

const MEDIA_URLS = [
    'ADP/',
    'Aether/',
    'AidenWestern/Test/comp3',
    'AidenWestern/Test/media3_vertical_v1',
    'AidenWestern/Test/text_media_2_story_v1',
    'AidenWestern/Test/text_media_2_v1',
    'Amkor/Quote3/Amkor_Quote3_Vert',
    'Avalara/Media%2003/Landscape/avalara_media03',
    'Avalara/Media4/Avalara-Media4',
    'Avalara/Title%2004/Landscape/avalara_title04_landcape',
    'Avalara/Title%2004/Vertical/avalara_title04_vertical',
    'Avalara/Title%2006/Vertical/avalara_title06_vertical',
    'Avalara/Title1/Avalara-Title1',
    'Avalara/Title2/Avalara-Title2',
    'Avalara/Title3/Avalara-Title3',
    'BENEO/BENEO-Text10',
    'BENEO/BENEO-Text8',
    'BENEO/BENEO-Text9',
    'Baker%20Hughes/Extra2/BakerHughes-Extra2',
    'BestWestern3/Title3/BestWestern3-Title3-Land-v2',
    'BestWestern3/BestWestern3-Title3',
    'BestWestern3/BestWestern3-Title4-Vert',
    'BestWestern3/Title4/BestWestern3-Title4-Land-v2',
    'BestWestern4/Icon3/BestWestern4-Icon3',
    'BestWestern4/Quote1/BestWestern4-Quote1',
    'Billow/',
    'Boldly/Boldly-Text5',
    'Boldly/Boldly-Text7',
    'Boldly/Title4/Boldly-Title4',
    'CBRE/CBRE-ChapterMarker1',
    'CBRE/CBRE-Extra7b-Vert',
    'Cadence%20Design%20Systems/CadenceDesign-Text2',
    'Cadence%20Design%20Systems/CadenceDesign-Text3',
    'Cadence%20Design%20Systems/CadenceDesign-Text4',
    'Cadence%20Design%20Systems/CadenceDesign-Title2',
    'Cadence%20Design%20Systems/CadenceDesign-Title3',
    'Cadence%20Design%20Systems/CadenceDesign-Title4',
    'Cadence%20Design%20Systems/List/cadence_list',
    'Cadence%20Design%20Systems/Text%2004B/CadenceDesign_ttext4b_bg',
    'Cadence%20Design%20Systems/CadenceDesign-Text4-Square',
    'Cadence%20Design%20Systems/Text%2005/CadenceDesign-Text5-Land_cubes',
    'Cadence%20Design%20Systems/Title%2001/CadenceDesign-Title1-Vert_v1',
    'Cadence%20Design%20Systems/Title%2001/CadenceDesign-Title1-Square_v1',
    'Cadence%20Design%20Systems/Title%2005/Landscape/CadenceDesign_title05_bg',
    'Cadence%20Design%20Systems/Title%2005/Square/CadenceDesign-Title5-Vert_bg',
    'Cadence%20Design%20Systems/Title%2005/Vertical/CadenceDesign_title05_Vertical_V5',
    'Cadence%20Design%20Systems/Title%2006/Vertical/CadenceDesign-Title6-Vert_bg',
    'Cadence%20Design%20Systems/Title%2007/Vertical/CadenceDesign-Title7-Vert_bg',
    'Cella/Icon%2004/Vertical/cella_icon04_vertical',
    'Cella/Icon%2004/Landscape/cella_icon04_landscape',
    'Cella/Icon%2004/Square/cella_icon04_square',
    'Cella/List2/Cella-List2',
    'Cella/Media1/Cella-Media1',
    'Cella/Media2/Cella-Media2',
    'Cella/Media4/Cella-Media4',
    'Cella/Media7/Cella-Media7',
    'Cella/Numeric4/Cella-Numeric4',
    'Cella/Quote%2003/Landscape/cella_quote03_landscape',
    'Cella/Quote%2003/Vertical/cella_quote03_vertical',
    'Cella/Quote1/Cella-Quote1-Vert',
    'Cella/Text1/Cella-Text1',
    'Cella/Title2/Cella-Title2',
    'Cella/Title3/Cella-Title3',
    'Cella/Title6/Cella-Title6',
    'CircleCI/CircleCI-Data1-Land%20v2',
    'CircleCI/CircleCI-Data1-Vert%20v2',
    'CircleCI/CircleCI-Data2-Vert%20v2',
    'CircleCI/CircleCI-List2-Land%20v2',
    'CircleCI/CircleCI-List2-Vert%20v2',
    'CircleCI/CircleCI-Outro1-Land',
    'CircleCI/CircleCI-Outro1-Vert',
    'CircleCI/CircleCI-Quote-Vert%20v2',
    'CircleCI/CircleCI-Quote-v1',
    'CircleCI/CircleCI-QuoteCaptions-Land%20v2',
    'CircleCI/CircleCI-QuoteCaptions-Vert%20v2',
    'CircleCI/CircleCI-TItle1-Vert%20v2',
    'CircleCI/CircleCI-TItle2-Land%20v2',
    'CircleCI/CircleCI-TItle2-Vert%20v2',
    'CircleCI/CircleCI-TItle3-Vert%20v2',
    'CircleCI/CircleCI-Text2-Land%203b%20v2',
    'CircleCI/CircleCI-Text4-Land%20v2',
    'CircleCI/CircleCI-Text4-Vert%20v2',
    'CircleCI/CircleCI-Text6-Vert%20v2',
    'CircleCI/CircleCI-Text7-Land',
    'CircleCI/CircleCI-Text7-Vert',
    'CircleCI/CircleCI-Text8-Land%20',
    'CircleCI/CircleCI-Text8-Vert',
    'Contour/Contour-Quote1-Land',
    'Contour/Contour-Quote1-Vertical',
    'Contour/Contour-QuoteCaptions',
    'Contour/Contour-Text10',
    'Contour/Contour-Text11',
    'Contour/Contour-Text7',
    'Contour/Contour-Text8',
    'Contour/Contour-Text9',
    'Contour/Contour-Title2',
    'Cosmo/Stat_01/Landscape/cosmo_textstat01_landscape_v3',
    'Cosmo/Stat_02/Landscape/cosmo_textstat02_landscape_v1',
    'Cosmo/Stat_02/Square/cosmo_textstat02_square_v1',
    'Cosmo/Stat_02/Vertical/cosmo_textstat02_vertical_v2',
    'Cosmo/Text_08/Landscape/cosmo_text08_landscape_v1',
    'Cosmo/Text_08/Square/cosmo_text08_square_v1',
    'Cosmo/Text_08/Vertical/cosmo_text08_vertical_v1',
    'Cosmo/Text_09/Landscape/cosmo_text09_landscape_v2',
    'Cosmo/Text_09/Square/cosmo_text09_square_v1',
    'Cosmo/Text_09/Vertical/cosmo_text09_vertical_v1',
    'Cosmo/Text_Default_Scene/Landscape/cosmo_dts_landscape_v2',
    'Cosmo/Text_Default_Scene/Vertical/cosmo_dts_vertical_v1',
    'Cosmo/Title_02/Landscape/cosmo_title02_landscape_v3',
    'Cosmo/Title_02/Square/cosmo_title02_square_v1',
    'Cosmo/Title_02/Vertical/cosmo_title02_vertical_v1',
    'Curly/',
    'D2L%20Wave/Listcle%20Heading%2002/Square/d2lwave_listicleheading02_landscape_v3',
    'D2L%20Wave/Listcle%20Heading%2002/Vertical/d2lwave_listicleheading02_vertical_v3',
    'D2L%20Wave/Quote%2001/Landscape/d2lwave_quote01_landscape',
    'D2L%20Wave/Quote%2001/Vertical/d2lwave_quote01_vertical',
    'D2L%20Wave/Quote%20Caption%20Scene/Landscape/d2lwave_quotecaptionscene_landscape_v2',
    'D2L%20Wave/Quote%20Caption%20Scene/Vertical/d2lwave_quotecaptionscene_vertical_v2',
    'D2L%20Wave/Stat%2001/Landscape/d2lwave_stat01_landscape_v2',
    'D2L%20Wave/Stat%2001/Vertical/d2lwave_stat01_vertical_v2',
    'D2L%20Wave/Text%2001/Landscape/d2lwave_text01_landscape_v2',
    'D2L%20Wave/Text%2001/Vertical/d2lwave_text01_vertical',
    'D2L%20Wave/Text%2001/Square/d2lwave_text01_square',
    'D2L%20Wave/Text%2002/Landscape/d2lwave_text02_landscape',
    'D2L%20Wave/Text%2002/Vertical/d2lwave_text02_vertical',
    'D2L%20Wave/Text%2002/Square/d2lwave_text02_square',
    'D2L%20Wave/Text%2002b/Vertical/d2lwave_title02b_vertical',
    'D2L%20Wave/Title%2002b/Square/d2lwave_title02b_square',
    'D2L%20Wave/Text%2002c/Landscape/d2lwave_text02c_landscape',
    'D2L%20Wave/Text%2002c/Vertical/d2lwave_text02c_vertical',
    'D2L%20Wave/Text%2002c/Square/d2lwave_text02c_square',
    'D2L%20Wave/Title%2001/Landscape/d2lwave_title01_landscape',
    'D2L%20Wave/Title%2001/Vertical/d2lwave_title01_vertical',
    'D2L%20Wave/Title%2001/Square/d2lwave_title01_square',
    'D2L%20Wave/Title%2001b/Landscape/d2lwave_title01b_landscape',
    'D2L%20Wave/Title%2001b/Vertical/d2lwave_title01b_vertical',
    'D2L%20Wave/Title%2001b/Square/d2lwave_title01b_square',
    'D2L%20Wave/Title%2002/Landscape/d2lwave_title02_landscape',
    'D2L%20Wave/Title%2002/Vertical/d2lwave_title02_vertical',
    'D2L%20Wave/Title%2002/Square/d2lwave_title02_square',
    'D2L%20Wave/Title%2002b/Landscape/d2lwave_text02b_landscape_v2',
    'D2L%20Wave/Title%2002b/Landscape/d2lwave_title02b_landscape',
    'D2L%20Wave/Text%2002b/Square/d2lwave_title02b_square',
    'D2L%20Wave/Title%2002b/Vertical/d2lwave_title02b_vertical',
    'D2L%20Wave/Title%2003/Landscape/d2lwave_title03_landscape',
    'D2L%20Wave/Title%2003/Vertical/d2lwave_title03_vertical',
    'D2L%20Wave/Title%2003/Square/d2lwave_title03_square',
    'D2L%20Wave/Title%2004/Landscape/d2lwave_title04_landscape',
    'D2L%20Wave/Title%2004/Vertical/d2lwave_title04_vertical',
    'D2L%20Wave/Title%2004/Square/d2lwave_title04_square',
    'DQS/DQS-List2',
    'DQS/DQS-Title1',
    'Dentons/Square/title01_square',
    'Dentons/Vertical/list_1_media_2_v1_vertical',
    'Dentons/Vertical/outro_vertical',
    'Dentons/Vertical/title01_vertical',
    'Dentons/list_1_media_2_v1',
    'Dentons/quotes-02_v2',
    'Dentons/title_01_blue_v1',
    'Dentons/title_landscape_v4',
    'Dentons/title_square_v4',
    'Dentons/title_vertical_v4',
    'EON/Carrier/EON_CarrierStroke_Icon1',
    'EON/Carrier/EON_CarrierStroke_Icon2',
    'EON/Carrier/EON_CarrierStroke_Icon3',
    'EON/EON-Title1-Lottie',
    'EON/EON-Title2-Lottie',
    'EON/EON-Title3-Lottie',
    'EON/EON-Title4-Lottie',
    'EON/EON-Title5-Lottie',
    'Eclipse/List%2001/Vertical/eclipse_list01_vertical',
    'Eclipse/List%2002/Landscape/eclipse_list02_landscape_v2',
    'Eclipse/List%2002/Vertical/eclipse_list02_vertical_v2',
    'Eclipse/Listicle%20Heading%2001/Vertical/eclipse_listicleheading01_vertical',
    'Eclipse/Quote%20Captions/Landscape/eclipse_quotecaptions_landscape_v3',
    'Eclipse/Quote%20Captions/Vertical/eclipse_quotecaptions_vertical_v2',
    'Eclipse/Stat%2001/Vertical/eclipse_stat01_vertical_v2',
    'Eclipse/Stat%2002/Landscape/eclipse_stat02_landscape_v2',
    'Eclipse/Stat%2002/Vertical/eclipse_stat02_vertical_v2',
    'Eclipse/Stat%2003/Vertical/eclipse_stat03_vertical_v2',
    'Eclipse/Text%2001/Vertical/eclipse_text01_vertical',
    'Eclipse/Text%2002/Landscape/eclipse_text02_landscape_v2',
    'Eclipse/Text%2002/Vertical/eclipse_text02_vertical_v2',
    'Eclipse/Text%2003/Vertical/eclipse_text03_vertical',
    'Eclipse/Text%2004/Landscape/eclipse_text04_landscape_v2',
    'Eclipse/Text%2004/Vertical/eclipse_text04_vertical_v2',
    'Eclipse/Text%2005/Vertical/eclipse_text05_vertical',
    'Eclipse/Text%2008/Landscape/eclipse_text08_landscape_v2',
    'Eclipse/Text%2009/Landscape/eclipse_text09_landscape',
    'Eclipse/Text%2009/Vertical/eclipse_text09_vertical',
    'Eclipse/Text%2009/Square/eclipse_text09_square',
    'Eclipse/Text%2010/Landscape/eclipse_text10_landscape_v2',
    'Eclipse/Text%2010/Vertical/eclipse_text10_vertical_v2',
    'Eclipse/Text%2010/Square/eclipse_text10_square_v2',
    'Eclipse/Text%2011/Landscape/eclipse_text11_landscape',
    'Eclipse/Text%2011/Vertical/eclipse_text11_vertical',
    'Eclipse/Text%2011/Square/eclipse_text11_square',
    'Eclipse/Text%2012/Landscape/eclipse_text12_landscape',
    'Eclipse/Text%2013/Landscape/eclipse_text13_landscape_v2',
    'Eclipse/Text%2013/Vertical/eclipse_text13_vertical_v2',
    'Eclipse/Text%20Default/Landscape/eclipse_textdefault_landscape_v2',
    'Eclipse/Text%20Default/Vertical/eclipse_textdefault_vertical_v2',
    'Eclipse/Title%2001/Vertical/eclipse_title01_vertical',
    'Eclipse/Title%2002/Vertical/eclipse_title02_vertical_v3',
    'Eclipse/Title%2004/Landscape/eclipse_title04_landscape_v2',
    'Emerson%20Full%20Control/Media4/EmersonFC_Media4',
    'Emerson%20Full%20Control/Media5/EmersonFC_Media5',
    'Emerson%20Full%20Control/Title4/EmersonFC_Title4',
    'Emerson%20Full%20Control/Title5/EmersonFC_Title5',
    'EvidentHealth/Icons1/EvidentHealth-Icons1',
    'EvidentHealth/Media5/EvidentHealth-Media5',
    'EvidentHealth/Quote1/EvidentHealth-Quote1',
    'EvidentHealth/Text1/EvidentHealth-Text1',
    'EvidentHealth/Text3/EvidentHealth-Text3',
    'EvidentHealth/Text4/EvidentHealth-Text4',
    'EvidentHealth/Text5/EvidentHealth-Text5',
    'EvidentHealth/Title1/EvidentHealth-Title1',
    'EvidentHealth/Title3/EvidentHealth-Title3',
    'EvidentHealth/Title4/EvidentHealth-Title4',
    'EvidentHealth/Title5/EvidentHealth-Title5',
    'EvidentHealth/Title6/EvidentHealth-Title6',
    'Flux/List%2001/Landscape/flux_list01_landscape',
    'Flux/Quote%2001/Landscape/%20flux_quote01_landscape_v1',
    'Flux/Quote%2001/Vertical/%20flux_quote01_vertical_v1',
    'Flux/Quote%2001/Square/%20flux_quote01_square_v1',
    'Flux/Text%2006/Vertical/flux_text06_vertical',
    'Flux/Text%2007/Vertical/flux_text07_vertical',
    'Flux/Text%2009/Landscape/flux_text09_landscape',
    'Flux/Text%2009/Vertical/%20flux_text09_vertical_v2',
    'Flux/Text%2009/Square/%20flux_text09_square_v2',
    'Flux/Text%2010/Landscape/flux_text10_landscape_v1',
    'Flux/Text%2010/Vertical/flux_text10_vertical_v1',
    'Flux/Text%2010/Square/flux_text10_square_v1',
    'Flux/Text%2011/Landscape/%20flux_text11_landscape_v1',
    'Flux/Text%2011/Vertical/%20flux_text11_vertical_v1',
    'Flux/Text%2011/Square/%20flux_text11_square_v1',
    'Flux/Text%2013/Landscape/flux_text13_landscape',
    'Flux/Title%2003/Vertical/flux_title03_vertical',
    'Foresight/',
    'Fox%20Weather/Icon2/FoxWeather-Icon2',
    'Fox%20Weather/Icon4/FoxWeather-Icon4',
    'Fox%20Weather/List3/FoxWeather-List3',
    'Fox%20Weather/Numeric1/FoxWeather-Numeric1',
    'Fox%20Weather/Numeric2/FoxWeather-Numeric2',
    'Fox%20Weather/Quotes1/FoxWeather-Quotes1',
    'Fox%20Weather/Quotes2/FoxWeather-Quotes2',
    'Fox%20Weather/Text1/FoxWeather-Text1',
    'Fox%20Weather/Title1/FoxWeather-Title1',
    'Fox%20Weather/Title4/FoxWeather-Title4',
    'Fox%20Weather/Title5/FoxWeather-Title5',
    'Freedom%20Mortgage/Quote%2002/Landscape/freedommortgage_quote02_landscape',
    'Freedom%20Mortgage/Quote%2002/Vertical/freedommortgage_quote02_vertical',
    'GFK/GFK-OutroC-Vert-1',
    'GFK_Test/Text_1',
    'GFK_Test/data_2',
    'GFK_Test/media_3',
    'GFK_Test/media_6',
    'GFK_Test/title2',
    'GFK_Test/title_1',
    'Garage%20by%20HP/Icon%201/Landscape/garagebyhp_icon01_landscape',
    'Geek/',
    'Hack22%20Voiceover/Text%2003/Landscape/hack22voiceover_text03_landscape',
    'Hack22%20Voiceover/Text%2003/Square/hack22voiceover_text03_square',
    'Hack22%20Voiceover/Text%2003/Vertical/hack22voiceover_text03_vertical',
    'Icon%20Scene%20Round%20Cut/Landscape/iconsceneroundcut_landscape',
    'Icon%20Scene%20Round%20Cut/Vertical/iconsceneroundcut_vertical',
    'Icon%20Scene%20Round%20Cut/Square/iconsceneroundcut_square',
    'InMoment/',
    'Insert%20Scenes/SplitscreenRounded/Insert-SplitscreenRounded-Vert',
    'Interlace/',
    'Johnson%20Matthey/',
    'Kaspersky2023/',
    'Keypath%20Education/Icon%2001/Square/keypath_icon01_square',
    'Keypath%20Education/Icon%2001/Vertical/keypath_icon01_vertical',
    'Keypath%20Education/Icon2/Keypath-Icon2',
    'Keypath%20Education/Outro/Keypath-Outro',
    'Keypath%20Education/Quote1/Keypath-Quote1',
    'Keypath%20Education/QuoteCaptions/Vertical/keypath_quotecaptions_vertical_v2',
    'Keypath%20Education/Title4/Keypath-Title4',
    'Lallemand/Icon%2002/Landscape/lallemand_icon02_landscape',
    'Lallemand/Icon%2002/Vertical/lallemand_icon02_vertical',
    'Lallemand/Icon%2002/Square/lallemand_icon02_square',
    'Lallemand/Media%2005/Landscape/lallemand_media05_landscape',
    'Lallemand/Media%2005/Vertical/lallemand_media05_vertical',
    'Lallemand/Media%2005/Square/lallemand_media05_square',
    'Lallemand/Media%2007/Landscape/lallemand_media07_landscape',
    'Lallemand/Media%2007/Vertical/lallemand_media07_vertical',
    'Lallemand/Media%2007/Square/lallemand_media07_square',
    'Lallemand/Title%2006/Landscape/lallemand_title06_landscape',
    'Lallemand/Title%2006/Vertical/lallemand_title06_vertical',
    'Lallemand/Title%2006/Square/lallemand_title06_square',
    'Lixil/',
    'Looper/',
    'Lumen5/',
    'Magnifique/',
    'Mazars2023/Waveform/Mazars2023-Waveform-Square-v2',
    'Mazars2023/Waveform/Mazars2023-Waveform-Vert-v2',
    'Memory/',
    'Ministry%20for%20Foreign%20Affairs%20of%20Finland/Quotes2/MFA-Quotes2',
    'Ministry%20for%20Foreign%20Affairs%20of%20Finland/Test/sphere_test_4',
    'Ministry%20for%20Foreign%20Affairs%20of%20Finland/Test/sphere_test_6',
    'Moodys/Outro/Moodys-Outro-Land',
    'Moodys/Outro/Moodys-Outro-Square',
    'Moodys/Outro/Moodys-Outro-Vert',
    'Moodys/Title3/Moodys-Title3-Vert-v2',
    'Notice/',
    'Orbit/Quotes%2001/Landscape/orbit_quotes01_landscape',
    'Orbit/Quotes%2001/Square/orbit_quotes01_square',
    'Orbit/Quotes%2001/Vertical/orbit_quotes01_vertical',
    'Orbit/Text%2009/Landscape/orbit_text09_landscape_v2',
    'Orbit/Text%2009/Vertical/orbit_text09_vertical_v2',
    'Orbit/Text%2009/Square/orbit_text09_square_v2',
    'Orbit/Text%2010/Landscape/orbit_text10_landscape_v2',
    'Orbit/Text%2010/Vertical/orbit_text10_vertical_v2',
    'Orbit/Text%2010/Square/orbit_text10_square_v2',
    'Orbit/Text%2011/Landscape/orbit_text11_landscape',
    'Orbit/Text%2011/Vertical/orbit_text11_vertical',
    'Orbit/Text%2011/Square/orbit_text11_square',
    'Orbit/Title%2003/Landscape/orbit_title03_landscape_v3',
    'Orbit/Title%2003/Vertical/orbit_title03_vertical_v3',
    'Orbit/Title%2003/Square/orbit_title03_square_v3',
    'Origin/Origin-List2',
    'Origin/Origin-Split1',
    'Origin/Origin-Split2',
    'Origin/Origin-Text3',
    'Origin/Origin-Text4',
    'Origin/Origin-Text7',
    'Origin/Origin-Text8',
    'Origin/Origin-Text9',
    'Origin/Origin-Title1',
    'Origin/Origin-Title2',
    'PG1/List1/PG1-List1',
    'PG1/Media2/PG1-Media2',
    'PG1/Media4/PG1-Media4',
    'PG1/Media5/PG1-Media5',
    'PG1/Numeric2/PG1-Numeric2',
    'PG1/Outro/PG1-Outro1',
    'PG1/Quote1/PG1-Quote1',
    'PG1/Quote2/PG1-Quote2',
    'PG1/TItle4/PG1-Title4',
    'PG1/Test/PG1-Outro1',
    'PG1/Text2/PG1-Text2',
    'PG1/Title1/PG1-Title1',
    'PG1/Title2/PG1-Title2',
    'PG1/Title3/PG1-Title3',
    'PG1/Title5/PG1-Title5',
    'PG1/Title6/PG1-Title6',
    'PG2/Outro/Vertical/pg2_outro',
    'PG2/Title%2001/Landscape/pg2_title01',
    'PG2/Title%2001/Vertical/pg2_title01',
    'PG2/Title%2001/Square/pg2_title01_square',
    'PG2/Title%2002/Landscape/pg2_title02_landscape',
    'PG2/Title%2002/Square/pg2_title02_square',
    'PG2/Title%2002/Vertical/pg2_title02_vertical',
    'PG2/Title%2003/Square/pg2_title03_square',
    'PG2/Title%2003/Landscape/pg2_title03_landscape',
    'PG2/Title%2003/Vertical/pg2_title03_vertical',
    'PG3/List2/PG3-List2',
    'PG3/Media3/PG3-Media3',
    'PG3/Media5/PG3-Media5',
    'PG3/Outro/PG3-Outro1',
    'PG3/Title4/PG3-Title4',
    'PG3/Title5/PG3-Title5',
    'PG4/Icon%2001/Landscape/pg4_icon01_landscape',
    'PG4/Icon%2001/Vertical/pg4_icon01_vertical',
    'PG4/List%2002/Square/pg4_list02_square',
    'PG4/List%2002/Landscape/pg4_list02_landscape',
    'PG4/List%2002/Vertical/pg4_list02_vertical',
    'PG4/Media%2005/Landscape/pg4_media05_landscape',
    'PG4/Media%2005/Vertical/pg4_media05_vertical',
    'PG4/Media%2005/Square/pg4_media05_square',
    'PG4/Media%2006/Landscape/pg4_media06_landscape',
    'PG4/Media%2006/Vertical/pg4_media06_vertical',
    'PG4/Media%2006/Square/pg4_media06_square',
    'PG4/Outro/Landscape/pg4_outro_landscape',
    'PG4/Outro/Vertical/pg4_outro_vertical',
    'PG4/Outro/Square/pg4_outro_square',
    'PG4/Quote%2001/Landscape/pg4_quote01_landscape',
    'PG4/Quote%2001/Vertical/pg4_quote01_vertical',
    'PG4/Quote%2001/Square/pg4_quote01_square',
    'PG4/Title%2006/Landscape/pg4_title06_landscape_v4',
    'PG4/Title%2006/Vertical/pg4_title06_vertical_v3',
    'PG4/Title%2006/Square/pg4_title06_square_v4',
    'Parker%20Hannafin/Icon2/ParkerHannifin-Icon2-',
    'Parker%20Hannafin/Media8/ParkerHannifin-Media8',
    'Parker%20Hannifin%20Test/parker_hannifin_media-02_v3',
    'Parker%20Hannifin%20Test/parker_hannifin_multimedia',
    'Parker%20Hannifin%20Test/parker_hannifin_outro',
    'Photon/Icon1/Photon-Icon1',
    'Photon/ListHead1/Photon-ListHead1',
    'Photon/ListHead2/Photon-ListHead2',
    'Photon/Media2/Photon-Media2',
    'Photon/Media3/Photon-Media3',
    'Photon/Media5/Photon-Media5',
    'Photon/Media6/Photon-Media6',
    'Photon/Outro1/Photon-Outro1',
    'Photon/Quote1/Photon-Quote1',
    'Photon/Quote2/Photon-Quote2',
    'Photon/SplitText1/Photon-SplitText1',
    'Photon/Stat1/Photon-Stat1',
    'Photon/Stat2/Photon-Stat2',
    'Photon/Text1/Photon-Text1',
    'Photon/Text2/Photon-Text2',
    'Photon/Text3/Photon-Text3',
    'Photon/Text4/Photon-Text4',
    'Photon/Text5/Photon-Text5',
    'Photon/Title4/Photon-Title4',
    'Photon/Title4/Photon-Title4',
    'Polaris/',
    'Robert%20Half/Media5/RobertHalf_Title2_Vert_V4',
    'Robert%20Half/Text3/RobertHalf_Text3_Vert_v2',
    'Robert%20Half/Title2/RobertHalf_Title2_Vert_V3',
    'Robert%20Half/Title7/RobertHalf_Title7',
    'Saturate/Saturate-Head1',
    'Saturate/Saturate-Outro5',
    'Saturate/Saturate-Quote1',
    'Saturate/Saturate-Quote2',
    'Saturate/Saturate-QuoteCaptions',
    'Saturate/Saturate-Stat1',
    'Saturate/Saturate-Text3',
    'Saturate/Saturate-Text4',
    'Saturate/Saturate-Text6',
    'Saturate/Saturate-Text7',
    'Saturate/Saturate-Text8',
    'Saturate/Saturate-Text9',
    'Saturate/Saturate-TextDefault',
    'Saturate/Saturate-Title1',
    'Saturate/Saturate-Title2',
    'Saturate/Saturate-Title3',
    'Saturate/Saturate-Title4',
    'Soleo%20Health/Media6/SoleoHealth-Media6',
    'Tracer/',
    'UNCG/Title6/UNCG-Title6-Vert-v1',
    'UST/Title2/UST-Title2',
    'Unilever/Media5/Unilever-Media5',
    'Unilever/Title5/Unilever-Title5',
    'Unilever/Media6/Unilever-Media6',
    'Unilever/Title5/Unilever-Title5',
    'Unity/',
    'Vault/Quote%2001/Landscape/vault_quote01_landscape2',
    'Vault/Quote%2001/Vertical/vault_quote01_vertical',
    'Vault/Quote%2001/Square/vault_quote01_square',
    'Vault/Text%2009/Landscape/vault_text09_landscape1',
    'Vault/Text%2009/Vertical/vault_text09_vertical',
    'Vault/Text%2009/Square/vault_text09_square',
    'Vault/Text%2010/Vertical/vault_text10_vertical',
    'Vault/Text%2010/Square/vault_text10_square',
    'Vault/Text%2010/Landscape/vault_text13_landscape',
    'Vault/Text%2011/Landscape/vault_text11_landscape',
    'Vault/Text%2011/Square/vault_text11_square',
    'Vault/Text%2011/Vertical/vault_text11_vertical',
    'Vertex/Comparison%2002/vertex_comparison02_landscape_new',
    'Vertex/Comparison%2002/vertex_comparison02_vertical_new',
    'Vertex/Quote%2001/vertex_quote01',
    'Vertex/Text%2005/vertex_text05',
    'Vertex/Text%2006/vertex_text06',
    'Vertex/Title%2003/vertex_title03',
    'Viatris/Text1/Viatris-Text1',
    'Viatris/Title6/Viatris-Title6',
    'Zayed%20University/Keypath-Title1-Vert-v1',
    'test/Foresight-Test1c',
];

const TRANSITION_URLS = [
    'ADP/ADP_Text03_Landscape',
    'ADP/Media%2010/adp_media10_landscape',
    'ADP/Title3/ADP_TItle03_Landscape_v2',
    'Kaspersky2023/Test/Kaspersky2023-Trans2-land-v4',
    'Kaspersky2023/Test/Kaspersky2023-Trans2-vert-v4',
    'Kaspersky2023/Test/Kaspersky2023-Trans2-vert-v4d',
    'Kaspersky2023/Transition1/Kaspersky2023-Trans1-vert-v4',
    'Parker%20Hannafin/Test/ParkerHannafin-Outro-Trans-Land-v1j',
    'Parker%20Hannafin/Test/ParkerHannafin-Outro-Trans-vert-v1a',
    'Photon/TransDiamond/Photon-DiamondOpen-land-v1',
    'Photon/TransDiamond/Photon-DiamondOpen-vert-v1',
    'Sulzer/Transitions/Test/Sulzer-TransitionColor-vert-v2b',
    'Transitions/01%20Fade/Landscape/transition_fade_landscape',
    'transitions/existing-transitions/ChevronDown/vertical',
    'transitions/existing-transitions/CircleRight/landscape',
    'transitions/existing-transitions/CircleSlow/landscape',
    'transitions/existing-transitions/CircleSlow/vertical',
    'transitions/existing-transitions/EraseLeft/landscape',
    'transitions/existing-transitions/EraseLeft/vertical',
    'transitions/existing-transitions/EraseLeft/square',
    'transitions/existing-transitions/FadeSlow/landscape',
    'transitions/existing-transitions/FadeSlow/vertical',
    'transitions/existing-transitions/GFKDiagonalSlide/landscape',
    'transitions/existing-transitions/GFKDiagonalSlide/vertical',
    'transitions/existing-transitions/RectangleDown/landscape',
    'transitions/existing-transitions/RectangleOpenHorizontal/landscape',
    'transitions/existing-transitions/RectangleOpenHorizontal/vertical',
    'transitions/existing-transitions/RectangleRight/landscape',
    'transitions/existing-transitions/SkewedRight/landscape',
    'transitions/existing-transitions/SkewedRight/vertical',
    'transitions/existing-transitions/SlideDown/vertical',
    'transitions/existing-transitions/SlideLeft/landscape',
    'transitions/existing-transitions/SlideLeft/vertical',
    'transitions/existing-transitions/Square/landscape',
    'transitions/input-push-mask-color',
];

function containsSubstring(arr, substring) {
    return arr.some(str => substring.includes(str));
}

export const migrationTo9_177 = createMigration({
    migrateVideo(video) {
        return video.withMutations(map => {
            map.get('slides').forEach((scene, i) => {
                map.setIn(['slides', i], this.migrateScene(scene));
            });
        });
    },
    migrateScene(scene) {
        return scene.withMutations(map => {
            // transition
            const transitionUrl = map.getIn(['customTransition', 'transitionUrl'], null) as string;
            if (transitionUrl) {
                const transitionRenderer = containsSubstring(TRANSITION_URLS, transitionUrl) ? 'svg' : 'canvas';
                map.setIn(['customTransition', 'renderer'], transitionRenderer);
            }
            // media
            map.get('children', []).forEach((asset, c) => {
                if (asset.get('classType') === 'LottieAsset') {
                    const renderer = containsSubstring(MEDIA_URLS, asset.get('sourceUrl').toString()) ? 'svg' : 'canvas';
                    map.setIn(['children', c, 'renderer'], renderer);
                }
            });
        });
    },
});
